/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { LocalisedString } from '../models/localised-string';
export interface DocumentWorkflowAction {

  /**
   * Code
   */
  code?: string | null;
  name?: LocalisedString;
}

export class DocumentWorkflowAction {
  code?: string | null;
  name?: LocalisedString;

  constructor(value: DocumentWorkflowAction) {
    this.code = value?.code;
    this.name = value?.name ? new LocalisedString(value.name) : undefined;
  }
}
